<div class="w-screen h-screen dark:bg-darkBack900">
  @if(loading()){
    <div class="flex items-center justify-center w-screen h-screen space-x-2">
      <div class="loader" style="animation-delay:-0.3s"></div>
      <div class="loader" style="animation-delay:-0.15s"></div>
      <div class="loader"></div>
    </div>
  }
  @else {
    <router-outlet />
  }
</div>
